import { TFunction } from "i18next";
import { Link } from "react-router-dom";

import { Button, Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

import { AssetType } from "@type/inventory/asset";
import { BrandType } from "@type/inventory/brand";
import { GroupType } from "@type/inventory/group";

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  selectProduct: any,
  selectedAssets: any,
) => {
  const { language } = useLanguage();

  return [
    {
      id: 1,
      key: "categoryName",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECT_PRODUCT_TABLE.COLUMN.CATEGORY",
      ),
      render: (_: string, row: AssetType) => {
        return <Text color="subtitle1">{row.group.category.name}</Text>;
      },
    },
    {
      id: 2,
      key: "group",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECT_PRODUCT_TABLE.COLUMN.GROUP",
      ),
      render: (group: GroupType, row: AssetType) => {
        return <Text color="subtitle1">{group.name}</Text>;
      },
    },
    {
      id: 3,
      key: "brand",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECT_PRODUCT_TABLE.COLUMN.BRAND",
      ),
      render: (brand: BrandType, row: AssetType) => {
        return <Text color="subtitle1">{brand.name}</Text>;
      },
    },
    {
      id: 4,
      key: "nameEn",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECT_PRODUCT_TABLE.COLUMN.ASSET_NAME",
      ),
      render: (nameEn: string, row: AssetType) => {
        let name = language === "bn" ? row.nameBn : row.nameEn;
        return <Text color="subtitle1">{name}</Text>;
      },
    },
    {
      id: 5,
      key: "type",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECT_PRODUCT_TABLE.COLUMN.TYPE",
      ),
      render: (type: string, row: AssetType) => {
        return <Text color="subtitle1">{type.toUpperCase()}</Text>;
      },
    },

    {
      id: 6,
      key: "action",
      render: (action: any, row: any) => {
        return (
          <div className="d-flex justify-content-end">
            {/* <Link to={`${row.id}`}> */}
            <Button
              fill="fill"
              type="primary"
              size="xs"
              className="me-5"
              onClick={() => selectProduct(row)}
              disabled={selectedAssets.some(
                (obj: AssetType) => obj.id === row.id,
              )}
            >
              {t(
                "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECT_PRODUCT_TABLE.COLUMN.SELECT_BUTTON",
              )}
            </Button>
            {/* </Link> */}
          </div>
        );
      },
    },
  ];
};
